import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';

import toggleColorPicker from '../../Functions/toggleColorPicker';

import Heading from './prorated/heading';
import General from './prorated/general';
import Field from './prorated/field';
import Button from './prorated/button';
import Result from './prorated/result';

class Prorated extends Component {
    constructor(props) {
        super(props);

        const { widget } = this.props;
        const { htmlData } = widget;

        this.state = {
            widget: {
                htmlData: {
                    prorated: {
                        general: {
                            containerBg: htmlData?.prorated?.general?.containerBg || '#ffffff',
                        },
                        heading: {
                            proratedHeading: htmlData?.prorated?.heading?.proratedHeading || 'Prorated Rent Calculator',
			                headingColor: htmlData?.prorated?.heading?.headingColor || '#8a2be2',
                            headingFontFamily: htmlData?.prorated?.heading?.headingFontFamily || 'Cabin',
                            headingFontSize: htmlData?.prorated?.heading?.headingFontSize || '36',
                            headingFontBold: htmlData?.prorated?.heading?.headingFontBold || 'off',
                            headingFontItalic: htmlData?.prorated?.heading?.headingFontItalic || 'off',
                            headingLabel: htmlData?.prorated?.heading?.headingLabel || '#495057',
                        },
                        field: {
                            fieldColor: htmlData?.prorated?.field?.fieldColor || '#495057',
                            fieldFontSize: htmlData?.prorated?.field?.fieldFontSize || '16',
                            fieldFontFamily: htmlData?.prorated?.field?.fieldFontFamily || 'Cabin',
                        },
                        button: {
                            buttonFontFamily: htmlData?.prorated?.button?.buttonFontFamily || 'Cabin',
                            buttonFontSize: htmlData?.prorated?.button?.buttonFontSize || '16',
				            buttonColor: htmlData?.prorated?.button?.buttonColor || '#8a2be2',
				            buttonBg: htmlData?.prorated?.button?.buttonBg || '#ffffff',
                            buttonBoxShadow: htmlData?.prorated?.button?.buttonBoxShadow || '#4361ee',
                            buttonHover: htmlData?.prorated?.button?.buttonHover || '#000000',
                            buttonHoverText: htmlData?.prorated?.button?.buttonHoverText || '#000000',
                            buttonHoverBg: htmlData?.prorated?.button?.buttonHoverBg || '#8a2be2',
                        },
                        result: {
                            resultLayout: htmlData?.prorated?.result?.resultLayout || 'vertical',
                            resultColor: htmlData?.prorated?.result?.resultColor || '#000000',
                            resultBg: htmlData?.prorated?.result?.resultBg || '#ffffff',
                            resultBorder: htmlData?.prorated?.result?.resultBorder || '#4361ee',
                        },
                    },
                },
                widgetType: widget.widgetType.id,
                widgetTypeName: widget.widgetType.name,
                widgetTypeScripts: widget.widgetType.scripts,
                title: widget.title ? widget.title : '',
                expires: widget.expires ? widget.expires : '',
                firstLoad: true,
            },
            previewHtml: '',
            fieldErrors: '',
        };

    }

    handleInputChange = (e) => {
        const { type, name, value, checked } = e.target;
    
        const updatedWidget = {
            ...this.state.widget,
            firstLoad: false,
            htmlData: {
                ...this.state.widget.htmlData,
                prorated: {
                    ...this.state.widget.htmlData.prorated,
                    [name]: value,
                    heading: {
                        ...this.state.widget.htmlData.prorated.heading,
                        [name]: type === 'checkbox' ? (checked ? 'on' : 'off') : value,
                    },
                    field: {
                        ...this.state.widget.htmlData.prorated.field,
                        [name]: type === 'checkbox' ? (checked ? 'on' : 'off') : value,
                    },
                    button: {
                        ...this.state.widget.htmlData.prorated.button,
                        [name]: type === 'checkbox' ? (checked ? 'on' : 'off') : value,
                    },
                    result: {
                        ...this.state.widget.htmlData.prorated.result,
                        [name]: type === 'checkbox' ? (checked ? 'on' : 'off') : value,
                    },
                },
            },
            [name]: value,
        };
    
        this.setState({ widget: updatedWidget });
    
        if (name !== 'title') {
            const { previewWidget } = this.props;
            previewWidget(updatedWidget);
        } else {
            const { updateWrapperWidget } = this.props;
            updateWrapperWidget(updatedWidget);
        }
    };

    async componentDidMount() {
        const { previewWidget } = this.props;
        await previewWidget(this.state.widget);
    }

    toggleColorPicker = (e) => {
        const picker = e.target.nextElementSibling;
        if (picker.style.display === "none") {
            picker.style.display = "flex";
        } 
        else {
            picker.style.display = "none";
        }
    }

    // common function for color pickers
    setColorsAndPreview = (section, stateItem, value) => {
        const updatedWidget = {
            ...this.state.widget,
            firstLoad: false,
            htmlData: {
                ...this.state.widget.htmlData,
                prorated: {
                    ...this.state.widget.htmlData.prorated,
                    [section]: {
                        ...this.state.widget.htmlData.prorated[section],
                        [stateItem]: value,
                    },
                },
            },
        };
    
        this.setState({ widget: updatedWidget });
    
        const { previewWidget } = this.props;
        previewWidget(updatedWidget);
    };


    render() {

        const { widget } = this.state;

        const { selectedEditor  } = this.props;

        const { title, htmlData } = widget;

        const { prorated } = htmlData;

        return (
            <div className="mjwi-editor-main-inner">

                {selectedEditor === 'Builder' && (
                    <div className="mjwi-editor-builder">

                        <label htmlFor="title">Widget Name</label>
                        <input
                            type="text"
                            name="title"
                            value={title}
                            placeholder="Title"
                            onChange={this.handleInputChange}
                        />

                    </div>
                )}
                {selectedEditor === 'Layout' && (
                    <div className="mjwi-editor-layout">

                        <General
                            widget = {widget}
                            handleInputChange = {this.handleInputChange}
                            toggleColorPicker = {toggleColorPicker}
                            setColorsAndPreview = {this.setColorsAndPreview}
                        />

                        <Accordion allowZeroExpanded={true}>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Heading
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>

                                    <Heading 
                                        widget = {widget}
                                        handleInputChange = {this.handleInputChange}
                                        toggleColorPicker = {toggleColorPicker}
                                        setColorsAndPreview = {this.setColorsAndPreview}
                                    />
                                
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Field
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>

                                    <Field 
                                        widget = {widget}
                                        handleInputChange = {this.handleInputChange}
                                        toggleColorPicker = {toggleColorPicker}
                                        setColorsAndPreview = {this.setColorsAndPreview}
                                    />
                                
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Button
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>

                                    <Button 
                                        widget = {widget}
                                        handleInputChange = {this.handleInputChange}
                                        toggleColorPicker = {toggleColorPicker}
                                        setColorsAndPreview = {this.setColorsAndPreview}
                                    />
                                
                                </AccordionItemPanel>
                            </AccordionItem>

                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Result
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>

                                    <Result 
                                        widget = {widget}
                                        handleInputChange = {this.handleInputChange}
                                        toggleColorPicker = {toggleColorPicker}
                                        setColorsAndPreview = {this.setColorsAndPreview}
                                    />
                                
                                </AccordionItemPanel>
                            </AccordionItem>

                        </Accordion>
                        

                    </div>
                )}


            </div>

        );
    }
}

export default Prorated;
